var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Axios from "axios";
function getFinishFromUrl(finishId, finishUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        const finishResponse = yield Axios.get(finishUrl);
        if (finishResponse.status >= 400) {
            throw new Error(`Failed to fetch finish '${finishId}' from '${finishUrl}'!`);
        }
        return finishResponse.data;
    });
}
function getSubstrateFromUrl(substrateId, substrateUrl) {
    return __awaiter(this, void 0, void 0, function* () {
        const substrateResponse = yield Axios.get(substrateUrl);
        if (substrateResponse.status >= 400) {
            throw new Error(`Failed to fetch substrate '${substrateId}' from '${substrateUrl}'!`);
        }
        return substrateResponse.data;
    });
}
export function loadSubstrateMap(config) {
    return __awaiter(this, void 0, void 0, function* () {
        const substrates = {};
        const promises = Object.keys(config.substrateUrlMap).map((substrateKey) => getSubstrateFromUrl(substrateKey, config.substrateUrlMap[substrateKey]).then((substrate) => {
            substrates[substrateKey] = substrate;
        }));
        yield Promise.allSettled(promises);
        return substrates;
    });
}
export function loadFinishMap(config) {
    return __awaiter(this, void 0, void 0, function* () {
        const finishes = {};
        if (!config.finishUrlMap) {
            return finishes;
        }
        const promises = Object.keys(config.finishUrlMap).map((finishKey) => __awaiter(this, void 0, void 0, function* () {
            if (!config.finishUrlMap)
                return;
            finishes[finishKey] = yield getFinishFromUrl(finishKey, config.finishUrlMap[finishKey]);
        }));
        yield Promise.allSettled(promises);
        return finishes;
    });
}
//# sourceMappingURL=materialLoader.js.map